// import React from 'react'
// import { FaSearch } from 'react-icons/fa';

// function Search() {
//   return (
//     <div className="input-group d-flex justify-content-center align-items-center">
//     <div className="form-outline"> {/* Use flex-grow-1 to expand the input field */}
//       <input
//         type="search"
//         placeholder='Search'
//         id="form1"
//         className="form-control sr"
//         style={{ maxWidth: '500px' }} // Set a maximum width for the input field
//       />
//     </div>
//     <button type="button" className="btn btn-search">
//       <FaSearch className="" />
//     </button>
//   </div>
//   )
// }

// export default Search

import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';

function Search({ frontendData, backendData, versionData }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResult, setSearchResult] = useState(null);

  const handleSearch = () => {
    const allData = [...frontendData, ...backendData, ...versionData];
    const matchingItem = allData.find(item =>
      item.title.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setSearchResult(matchingItem);
  };

  const handleChange = e => {
    setSearchQuery(e.target.value);
  };

  return (
    <div>
      <div className="input-group d-flex justify-content-center align-items-center">
        <div className="form-outline">
          <input
            type="search"
            placeholder="Search"
            id="form1"
            className="form-control sr"
            style={{ maxWidth: '500px' }}
            value={searchQuery}
            onChange={handleChange}
          />
        </div>
        <button type="button" className="btn btn-search" onClick={handleSearch}>
          <FaSearch />
        </button>
      </div>

      <div>
        {/* Display the matching card */}
        {searchResult && (
          <div key={searchResult.id} className="track-card">
            <h2>{searchResult.title}</h2>
            <p>{searchResult.description}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Search;
